import styled from 'styled-components'

export const StyledCarousel = styled.div`
    height: 100vh;
    width: 100vw;
    margin-top: -2px;

    
`